import script from "./FaqList.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqList.vue?vue&type=script&setup=true&lang=js"

import "./FaqList.vue?vue&type=style&index=0&id=616deeca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-616deeca"]])

export default __exports__